export default __webpack_public_path__ + "static/schedule_title_background-a8dde12059e7f3bd599c5b96c7145812.png";